module.exports = __webpack_public_path__ + "products-icon.bd0c211352550d7ac97ce4fbbce885e2.svg";